const Enum = {
  GENDER: {
    MALE: 0,
    FEMALE: 1,
    OTHER: 2
  },
  ROLE: {
    GENERAL_MANAGER: "GENERAL_MANAGER",
    HEAD_DEPARTMENT: "HEAD_DEPARTMENT",
    LINE_MANAGER: "LINE_MANAGER",
    STAFF: "STAFF"
  },
  NOTICE_TERMINATION: {
    YES: 1,
    NO: 0
  },
  PAYROLL_ITEM_TYPE: {
    TAXABLEEARNING: 0,
    NONTAXABLEEARNING: 1,
    DEDUCTION: 2,
    EXCLUDE: 3,
    PENSION_FUND: 4,
    TAXABLE_DEDUCTION: 5,
    ALLOWANCE: 6
  },
  PAYROLLTIEMFORMULAR: {
    EARNING: 0,
    DEDUCTION: 1,
    NONE: 2
  },
  OVERTIMETYPE: {
    HOLIDAY: 1,
    NORMAL: 2,
    NIGHTSHIFT: 3,
    DAYOFF: 4,
    COMPENSATION: 5,
  },
  LEAVESTATUS: {
    REQUESTED: 0,
    APPROVED: 1,
    REJECTED: 2,
    CANCELLED: 3,
    REVIEWED: 4,
    REQUEST_CANCEL: 5,
  },
  LEAVE_TYPE: {
    ANNUAL_LEAVE: 1,
    SICK_LEAVE: 2,
    MATERNITY: 3,
    PATERNITY_LEAVE: 4,
    SPECIAL_LEAVE: 5,
    UNPAID_LEAVE: 6,
    COMPENSATION: 7,
    JOB_SEEKING_LEAVE: 8
  },
  ATTENDANCE_TYPE: {
    PRESENCE: 1,
    ABSENT: 2,
    DAYOFF: 3,
    REQUEST_TIME: 4,
    HOLIDAY: 5
  },
  ATTENDANCE_STATUS: {
    REQUEST: 0,
    APPROVED: 1,
    REJECTED: 2,
    CANCELLED: 3,
  },
  TASK_STATUS: {
    COMPLETED: 1,
    PROGRESS: -1,
    PENDING: 0,
  },
  TRUE_FALSE: {
    FALSE: 0,
    TRUE: 1,
  },
  CONTRACT_TYPE: {
    UDC: "UDC",
    FDC: "FDC",
    VOLUNTEER: "VOLUNTEER",
    CONSULTANT: "CONSULTANT",
    INTERNSHIP: "INTERNSHIP",
  },
  OBJECTIVES_SETTING: {
    PENDING: "PENDING",
    SUBMITTED: "SUBMITTED",
    APPROVED: "APPROVED",
    REJECTED: "REJECTED",
    REQUIRED_UPDATE: "REQUIRED_UPDATE",
  }
};

export default Enum;
